import { render, staticRenderFns } from "./NavLinkItem.vue?vue&type=template&id=ea767dfa&scoped=true&"
import script from "./NavLinkItem.vue?vue&type=script&lang=js&"
export * from "./NavLinkItem.vue?vue&type=script&lang=js&"
import style0 from "./NavLinkItem.vue?vue&type=style&index=0&id=ea767dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea767dfa",
  null
  
)

export default component.exports